import { useEffect, useState } from 'react';
import { FaQuestionCircle, FaDollarSign, FaCheck, FaFire, FaLock } from 'react-icons/fa';
import { socket } from '../Containers/MainContainer';
import { USDWithCommas, getShownCurency, numberWithCommas, showDailyStreakModal } from '../utils';
import ProgressiveImage from 'react-progressive-image-loading';
import '../../SevenDaysStreakStyle.css';

function SevenDayStreak(props) {
    const [hapa, setHandleAmount] = useState(getShownCurency() == 'usd' ? 1 : 0);
    const [streakData, setStreakData] = useState({
        currentDay: 0,
        amountNeeded: 1000.00,
        claimedToday: false,
        timeRemaining: '00:00:00',
        dailyRewards: [0,0,0,0,0,0,0],
        canClaim: true,
        claimedDays: []
    });
    const [showInfo, setShowInfo] = useState(false);

    function handleAmount(am) {
        if (hapa == 1) {
            return USDWithCommas(am);
        } else {
            return numberWithCommas(am);
        }
    }

    useEffect(() => {
        window.addEventListener('shownCurrency', () => {
            if (getShownCurency() == 'usd') {
                setHandleAmount(1);
            } else {
                setHandleAmount(0);
            }
        });
    }, [getShownCurency()]);
    function resetTimer() {
        if(streakData.timeRemaining <=0){
            socket.emit('getStreakData');
         
        }
        setInterval(() => {
            setStreakData(prevData => ({
                ...prevData,
                timeRemaining: prevData.timeRemaining > 0 ? prevData.timeRemaining - 1 : 0
            }));
        }, 1000);
    }
    useEffect(() => {
        // Request streak data from backend
        socket.emit('getStreakData');

        socket.on('emitStreakData', (data) => {
            setStreakData({...data});
            for(let i=0;i<data.claimedDays.length;i++){
                setStreakData(prevData => ({
                    ...prevData,
                    claimedDays: [...prevData.claimedDays, i]
                }));
            }
            resetTimer()
        });

        // Update timer every second
       

    }, []);

    const handleClaim = () => {
        if (streakData.canClaim && props.logged && !props.banned) {
            socket.emit('userAction', {
                action: 'claim_daily_streak',
            });
            socket.emit('getStreakData');

        }
    };

    const getDayLabel = (index) => {
        if (index == streakData.currentDay) return 'Today';
        return `D${index + 1}`;
    };

    const isDayActive = (index) => {
        return index == streakData.currentDay;
    };

    const isDayClaimed = (index) => {
        return streakData.claimedDays.includes(index) || (index == streakData.currentDay && streakData.claimedToday);
    };

    const getDayClass = (index) => {
        let classes = 'streak-day-item';
        if (isDayActive(index)) classes += ' active';
        if (isDayClaimed(index)) classes += ' claimed';
        return classes;
    };

    const formatTime = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    };

    return (
            <div className="streak-main-container">
                <div className="streak-header">
                    <div className="streak-header-left">
                        <FaFire className="streak-fire-icon" />
                        <h4 className="streak-title">7-Day Streak</h4>
                        <FaQuestionCircle
                            className="streak-help-icon"
                            onClick={() => showDailyStreakModal()}
                        />
                    </div>
                    <span className="streak-time-remaining">{formatTime(streakData.timeRemaining)}</span>
                </div>

                <div className="streak-status-text">
                    {streakData.claimedToday ? (
                        <span>Come back tomorrow for bigger rewards!</span>
                    ) : (
                        <span>Earn <strong className="streak-amount-needed">
                            {hapa == 1 ? <FaDollarSign style={{ fontSize: '11px', display: 'inline' }} /> :
                            <ProgressiveImage
                                preview="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                src="/assets/img/faucetify_coin_small.png"
                                render={(src, style) => <img alt="coin" width={10} height={10} src={src} style={{ display: 'inline', marginRight: '2px' }} />}
                            />}
                            {handleAmount(streakData.amountNeeded)}
                        </strong> more today to keep your streak!</span>
                    )}
                </div>

                <div className="streak-days-container">
                    <div className="streak-days-track">
                        <div className="streak-days-progress" style={{ width: `${(Math.max(0, streakData.currentDay) / 6) * 100}%` }} />
                    </div>
                    <div className="streak-days-wrapper">
                        {streakData.dailyRewards.map((reward, index) => (
                            <div key={index} className={getDayClass(index)}>
                                <div className={`streak-day-circle ${isDayClaimed(index) ? 'claimed' : isDayActive(index) ? 'active' : 'locked'}`}>
                                    {isDayClaimed(index) ? (
                                        <FaCheck className="streak-check-icon" />
                                    ) : isDayActive(index) ? (
                                        <FaFire className="streak-active-icon" />
                                    ) : (
                                        <FaLock className="streak-lock-icon" />
                                    )}
                                </div>
                                <div className="streak-day-label">{getDayLabel(index)}</div>
                                <div className={`streak-day-reward ${isDayClaimed(index) ? 'claimed' : isDayActive(index) ? 'active' : 'locked'}`}>
                                    {index == 6 ? (
                                        <><span className="day-7-label">up to</span>${reward}</>
                                    ) : (
                                        <>${reward}</>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    className="streak-claim-btn"
                    onClick={handleClaim}
                    disabled={!streakData.canClaim || !props.logged || props.banned}
                >
                    <FaFire style={{ fontSize: '12px' }} />
                    {streakData.canClaim ? 'Claim Reward' : 'Claimed'}
                </button>
            </div>
    );
}

export default SevenDayStreak;
